import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';

import { Icon } from 'ui';
import request from 'utils/request_ajax.js';
import { routes as ROUTES } from 'constants/config';
import * as selectors from 'selectors/pathBuilder';
import Section, { SectionHeader } from './Section';
import SaveButton from './partials/SaveButton';
import * as actions from '../../../actions/pathBuilder';

class Description extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
    this.handleKeydown = this.handleKeydown.bind(this);
    this.updateDescription = this.updateDescription.bind(this);
    this.setInputRef = this.setInputRef.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.editing && !prevProps.editing) {
      global.autosize(this.input);
    }
  }

  updateDescription() {
    const change = { description: this.input.value.trim() };
    if (this.props.pathId) {
      this.setState({ loading: true }, () => {
        request
          .put(ROUTES.PATHS + `/${this.props.pathId}`, change)
          .then(res => {
            this.props.updatePath({ description: res.description });
            this.setState({ loading: false }, this.props.toggleEditing);
          });
      });
    } else {
      this.props.updatePath(change);
      this.props.toggleEditing();
    }
  }

  setInputRef(node) {
    if (node) {
      this.input = node;
      this.input.focus();
    }
  }

  handleKeydown(e) {
    if (e.keyCode === 13 && e.metaKey && !this.isEmpty) {
      this.updateDescription();
    }
  }

  render() {
    const {
      editing,
      toggleEditing,
      isArchived,
      userCanEditContent,
      isCertification,
    } = this.props;
    return (
      <Section>
        <SectionHeader className="d-f jc-sb" htmlFor="pathDescription">
          {!isCertification &&
            t('paths.path_builder.sidebar.description_title')}
          {isCertification &&
            t('certifications.certification_builder.sidebar.description_title')}
          {!isArchived &&
            !editing &&
            this.props.description &&
            userCanEditContent && (
              <button
                type="button"
                className="u-linkBtn fz-base fw-n"
                onClick={toggleEditing}
              >
                <Icon name="edit" className="mr-4" />
                Edit
              </button>
            )}
        </SectionHeader>
        {!editing && this.props.description && (
          <p className="m-0 ws-pr">{this.props.description}</p>
        )}
        {!isArchived &&
          !editing &&
          !this.props.description &&
          userCanEditContent && (
            <button
              type="button"
              className="u-linkBtn fz-base fw-n td-n"
              onClick={toggleEditing}
            >
              <Icon name="add" /> Add Description
            </button>
          )}
        {!this.props.description && (isArchived || !userCanEditContent) && (
          <span className="c-brand-gray-darker">No Description</span>
        )}
        {editing && (
          <div>
            <textarea
              id="pathDescription"
              className="Textarea w-fill"
              placeholder={
                isCertification
                  ? t(
                      'certifications.certification_builder.sidebar.description_placeholder',
                    )
                  : t('paths.path_builder.sidebar.description_placeholder')
              }
              ref={this.setInputRef}
              defaultValue={this.props.description}
              onKeyDown={this.handleKeydown}
            />
            <div className="d-f jc-e ai-c mt-8">
              <button
                type="button"
                className="u-linkBtn u-linkBtn--dark td-u"
                onClick={toggleEditing}
                children="Cancel"
              />
              <SaveButton
                loading={this.state.loading}
                onClick={this.updateDescription}
              />
            </div>
          </div>
        )}
      </Section>
    );
  }
}

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  pathId: pathBuilder.id,
  description: pathBuilder.description,
  editing: pathBuilder.editingDescription,
  isArchived: selectors.isArchived(pathBuilder),
  isCertification: !!get('certification')(pathBuilder),
  userCanEditContent: pathBuilder.permissions.editPath,
});

const mapDispatchToProps = {
  updatePath: actions.updatePath,
  toggleEditing: actions.toggleEditingDescription,
};

export default connect(mapStateToProps, mapDispatchToProps)(Description);
